import { SelfApplyGuard } from "modules/self-apply/common/pages/connected-self-apply-guard";
import { getChildByTypeNullable } from "@/components/layouts/get-child-by-type";
import { Slot } from "@/components/layouts/slot";

import { SELF_APPLY_USER_TYPE_ENUM } from "modules/self-apply/types/self-apply-user-type";
import { StickySidebarPageLayout } from "modules/self-apply/layouts/sticky-sidebar-layout";

const Header = Slot();
const Filters = Slot();
const Content = Slot();

export const Container = (props: {
  children: React.ReactNode;
  selfApplyUserType: SELF_APPLY_USER_TYPE_ENUM;
}) => {
  const header = getChildByTypeNullable(props.children, Header);
  const filters = getChildByTypeNullable(props.children, Filters);
  const content = getChildByTypeNullable(props.children, Content);

  return (
    <SelfApplyGuard selfApplyUserType={props.selfApplyUserType}>
      <StickySidebarPageLayout.Container>
        <StickySidebarPageLayout.Header>
          {header}
        </StickySidebarPageLayout.Header>
        <StickySidebarPageLayout.DesktopSidebar>
          <div className="pt-6 w-[330px]">{filters}</div>
        </StickySidebarPageLayout.DesktopSidebar>
        <StickySidebarPageLayout.Content>
          <div className="w-full gap-y-4 pt-6 flex flex-col">{content}</div>
        </StickySidebarPageLayout.Content>
      </StickySidebarPageLayout.Container>
    </SelfApplyGuard>
  );
};

export const BaseJobListPage = {
  Container,
  Header,
  Filters,
  Content,
};
